/**
 */

(function () {

    "use strict";

    Backbone.Collection.DEFAULT_PAGE_SIZE = 25;
    Backbone.Collection.DEFAULT_PAGINATION_THRESHOLD = 250;

    Backbone.Collection.IMPLICIT_PAGE_SIZE = 250;
    Backbone.Collection.IMPLICIT_PAGINATION_THRESHOLD = 100;
    Backbone.Collection.QUICK_NAP_BETWEEN_PAGES = 1;

    Backbone.Collection.paginationThreshold = function() {
        var customPaginationThreshold;
        if (Core && Core.client && Core.client.groups) {
            Core.client.groups.forEach(function(group){
                if (group.get("configuration")) {
                    const groupPaginationThreshold = group.get("configuration")["pagination_threshold"]
                    if (!isNaN(groupPaginationThreshold) && (!customPaginationThreshold || parseInt(groupPaginationThreshold) < customPaginationThreshold)) {
                        customPaginationThreshold = parseInt(groupPaginationThreshold);
                    }
                }
            })
        }
        return customPaginationThreshold || Backbone.Collection.DEFAULT_PAGINATION_THRESHOLD;
    };

    Backbone.Collection.prototype.countUrl = function() {
        var url = typeof this.url == 'function' ? this.url() : this.url;
        url = url.replace('/search', '');
        var index = url.indexOf('?');
        if (index >= 0)
            return url.substring(0,index) + '/count' + url.substring(index);
        else
            return url + '/count';
    };

    Backbone.Collection.prototype.getCachedOrFetchCount = function(callback, scope) {
        if (this.cacheOptions && this.cacheOptions.key && sessionStorage[this.cacheOptions.key + '_totalCount']) {
            var count = parseInt(sessionStorage[this.cacheOptions.key + '_totalCount']);
            this.totalCount = count;
            if (callback) callback.apply(scope, [count]);
            return count;
        } else {
            return this.fetchCount().success(function (count) {
                if (callback) callback.apply(scope, [parseInt(count)]);
            });
        }
    };

    Backbone.Collection.prototype.fetchCount = function() {
        var self = this;
        this.loadingCount = true;
        return $.get(this.countUrl()).success(function (count) {
            self.totalCount = parseInt(count);
            if (self.cacheOptions && self.cacheOptions.key) sessionStorage[self.cacheOptions.key + '_totalCount'] = count;
            self.trigger('count', count);
        }).complete(function() { self.loadingCount = false; });
    };

    Backbone.Collection.prototype.getCachedOrFetchIfNotPaginated = function(callback) {
        if (!this.canPaginate) return this.getCachedOrFetch(callback);
        var self = this;
        this.getCachedOrFetchCount(function(count) {
            if (count > Backbone.Collection.paginationThreshold()) {
                console.log('paginating ' + self.url());
                if (callback) callback();
            } else {
                self.getCachedOrFetch(callback);
            }
        });

    };

    Backbone.Collection.prototype.fetchPage = function(page, options) {
        if (typeof page == 'object' && !options) {
            options = page;
            page = undefined;
        }
        if (page) this.currentPage = page;
        if (!this.currentPage) {
            if (this.cacheOptions && this.cacheOptions.key) {
                if (sessionStorage[this.cacheOptions.key + '_pageSize'])
                    this.pageSize = parseInt(sessionStorage[this.cacheOptions.key + '_pageSize']);
                if (sessionStorage[this.cacheOptions.key + '_currentPage'])
                    this.currentPage = parseInt(sessionStorage[this.cacheOptions.key + '_currentPage']);
            }
        }
        if (!this.currentPage) this.currentPage = 1;
        if (!this.pageSize) this.pageSize = Backbone.Collection.DEFAULT_PAGE_SIZE;
        if (this.currentPage > this.totalPages()) this.currentPage = this.totalPages();
        if (!options) options = {};
        var opts = _(options).extend({data: {limit: this.pageSize, offset: (this.currentPage-1)*this.pageSize}});
        if (!options.reset) opts.remove = false;
        var self = this;
        this.trigger('page-fetch');
        return this.fetch(opts).success(function(data) {
            if (self.cacheOptions && self.cacheOptions.key) {
                delete sessionStorage[self.cacheOptions.key];
                delete sessionStorage[self.cacheOptions.key + '_ttl'];
                sessionStorage[self.cacheOptions.key + '_currentPage'] = self.currentPage;
            }
            if (data.length)
                self.trigger('page-add', data);
            else
                self.trigger('page-empty', data);
        });
    };

    Backbone.Collection.prototype.fetchNextPage = function(options) {
        if (!this.currentPage)
            this.currentPage = 0;
        this.currentPage++;
        return this.fetchPage(options);
    };

    Backbone.Collection.prototype.fetchPrevPage = function(options) {
        if (!this.currentPage)
            this.currentPage = 2;
        this.currentPage--;
        return this.fetchPage(options);
    };

    Backbone.Collection.prototype.fetchFirstPage = function(options) {
        return this.fetchPage(1, options);
    };

    Backbone.Collection.prototype.fetchLastPage = function(options) {
        if (!this.totalCount) return;
        return this.fetchPage(this.totalPages(), options);
    };

    Backbone.Collection.prototype.totalPages = function() {
        if (!this.pageSize) this.pageSize = Backbone.Collection.DEFAULT_PAGE_SIZE;
        return Math.ceil(this.totalCount / this.pageSize);
    };

    Backbone.Collection.prototype.isPaginated = function() {
        return this.totalCount && this.length < this.totalCount && (isFinite(this.currentPage) || this.totalCount > Backbone.Collection.paginationThreshold());
    };

    Backbone.Collection.prototype.updateCache = function() {
        if (this.length > Backbone.Collection.paginationThreshold())
            console.error('Warning: updateCache() over pagination threshold ' + (this.cacheOptions ? this.cacheOptions.key : null));
        Backbone.Model.prototype.updateCache.apply(this);
    };

    Backbone.Collection.prototype.setPageSize = function(pageSize) {
        this.pageSize = parseInt(pageSize) || Backbone.Collection.DEFAULT_PAGE_SIZE;
        if (this.cacheOptions && this.cacheOptions.key) {
            sessionStorage[this.cacheOptions.key + '_pageSize'] = this.pageSize;
        }
    }

} ());
